// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"7261e5d2","396":"7261e5d2","565":"7261e5d2","819":"e1ed7ff5","962":"7261e5d2"}[chunkId] + ".css";
};